import { render, staticRenderFns } from "./_base-delete-button.vue?vue&type=template&id=cd8f1a5c&"
import script from "./_base-delete-button.vue?vue&type=script&lang=js&"
export * from "./_base-delete-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports